import { TPagination } from "@custom-types/sorting";

import { CostRules } from "./cost-rules.model";
import { FinancialInstitute } from "./financial-insitute.model";

export type TAdvisorsPaginated = TPagination & {
  data: Array<AdvisorModel>;
};

export interface AdvisorModel {
  email: string;
  firstName: string;
  id: string;
  isLockedOut: boolean;
  lastName: string;
  lastNamePrefix: string;
  lockoutEndDateUtc: string;
  userName: string;
  version: string;
  phoneNumber: string;
  iban: string;
  accountHolder: string;
  advisorFee: CostRules;
  advisorBank: FinancialInstitute;
}

export class Advisor implements AdvisorModel {
  email = "";
  firstName = "";
  id = "";
  isLockedOut = false;
  lastName = "";
  lastNamePrefix = "";
  lockoutEndDateUtc = "";
  userName = "";
  version = "";
  phoneNumber = "";
  iban: string = "";
  accountHolder = "";
  advisorFee = new CostRules();
  advisorBank = new FinancialInstitute();

  constructor(dto?: AdvisorModel) {
    Object.assign(this, dto);
  }
}
